export default "/kiban/_next/static/images/otherSilk-6abca207e954189baf7a018920aaef75.png";